module.exports = __webpack_public_path__ + "img/mat.2f477dce.gif";